import {
  USER_FRUI_ZZZZ_MODAL_CHANGE,
} from './constants';

export function frui_zzzzModalChange(visible) {
  return {
    type: USER_FRUI_ZZZZ_MODAL_CHANGE,
    data: {visible},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_FRUI_ZZZZ_MODAL_CHANGE:
      return {
        ...state,
        frui_zzzzModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/frui_zzzzModalChange.js